import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { PageStructureEffects } from './page-structure-feature.effects';
import { PageStructureFacades } from './page-structure-feature.facades';
import { PAGE_STRUCTURE_FEATURE_KEY, pageStructureReducer } from './page-structure-feature.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(PAGE_STRUCTURE_FEATURE_KEY, pageStructureReducer),
        EffectsModule.forFeature(PageStructureEffects),
    ],
    providers: [...PageStructureFacades],
    declarations: [],
})
export class PageStructureStoreModule {}
